<template>
  <div>
    <span v-for="(product_type, index) in product_set.product_types" :key="index">
      <create-content
        :modal_id="'modal-process-v2-' + lot_id"
        :lot="lot"
        :lot_id="lot_id"
        :product_type="product_type"
        :product_id="product_id"
        :net_kilograms_sum_in="net_kilograms_sum_in"
        :net_kilograms_sum_out="net_kilograms_sum_out"
        :productSet="product_set"
      ></create-content>
    </span>
  </div>
</template>

<script>
import CreateContent from "@/views/proceso-v2-alfa/CreateContent";
export default {
  name: "CreateContentButton",
  components: {
    CreateContent
  },
  props: {
    lot: {
      type: String,
      default: ""
    },
    net_kilograms_sum_in: {
      type: String,
      default: "0"
    },
    net_kilograms_sum_out: {
      type: String,
      default: "0"
    },
    lot_id: {
      type: Number,
      default: 0
    },
    product_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      product_set: {
        containers: [],
        exportable_containers: [],
        product_types: [],
        spec_type: [],
        varieties: []
      },
      loading: true
    };
  },
  watch: {
    product_id(n_val) {
      if (n_val) {
        this.getProductSet(this.product_id);
      }
    }
  },
  mounted() {
    this.getProductSet(this.product_id);
  },
  methods: {
    // Exclude 'Granel' from product types
    excludeGranel(product_types) {
      return product_types.filter((product_type) => {
        return product_type.text !== "Granel";
      });
    },
    async getProductSet(a) {
      const thisV = this;
      thisV.loading = false;
      try {
        const res = await this.$axios.get("/production/get_product_set/" + a);
        thisV.product_set = res.data;
        if (this.$store.state.user.ID_CLIENTE === 4) {
          console.log("Excluyendo Granel...", this.$store.state.user.ID_CLIENTE);
          thisV.product_set.product_types = thisV.excludeGranel(thisV.product_set.product_types);
        }
        thisV.loading = false;
      } catch (error) {
        thisV.$toast.error("Ocurrio un error al cargar datos", "");
        console.log(error);
        thisV.loading = false;
      }
    }
  }
};
</script>

<style scoped></style>
